"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonNegativeIntegerValue = isNonNegativeIntegerValue;
exports.getInstallmentPlanDisplayLogicValidationError = getInstallmentPlanDisplayLogicValidationError;
var enums_1 = require("./enums");
function isNonNegativeIntegerValue(value) {
    if (typeof value !== 'string' && typeof value !== 'number')
        return false;
    return /^(0|[1-9]\d*)$/.test(String(value !== null && value !== void 0 ? value : ''));
}
function getInstallmentPlanDisplayLogicValidationError(input) {
    if (input.hasConflictingSourceReference) {
        return 'Display condition source ID does not match its source relation';
    }
    if (input.sourceReferenceCount !== 1) {
        return 'Exactly one display condition source reference must be specified';
    }
    if (input.sourceCustomType !== 'INSTALLMENT_PLANS' ||
        input.targetCustomType !== 'GUARANTOR' ||
        !input.sourceFormId ||
        input.sourceFormId !== input.targetFormId) {
        return 'Installment Plans source and Guarantor target must belong to the same form';
    }
    if (input.sourcePageSequence === undefined ||
        input.targetPageSequence === undefined ||
        input.sourcePageSequence > input.targetPageSequence) {
        return 'Installment Plans source must be on the same or an earlier page than the Guarantor target';
    }
    var isNumericOperator = [
        enums_1.ValueOperator.Equals,
        enums_1.ValueOperator.NotEqual,
        enums_1.ValueOperator.GreaterThan,
        enums_1.ValueOperator.LessThan,
    ].includes(input.sourceOperator);
    if (![enums_1.DisplayAction.Show, enums_1.DisplayAction.Hide, enums_1.DisplayAction.Require].includes(input.displayAction) ||
        !isNumericOperator ||
        input.valueCount !== 1 ||
        input.hasFieldOptionValue ||
        !isNonNegativeIntegerValue(input.value)) {
        return 'Invalid Installment Plans conditional source configuration';
    }
}
